import gql from 'graphql-tag';

export const GET_ADMIN_DASHBOARD_LIST_OPTIONS = gql`
  query GetAdminDashboardListOptions($input: ExternalDashboardsAdminInput!) {
    externalDashboards {
      result: externalAdminDashboards(input: $input) {
        error
        success
        list {
          value: id
          label: name
        }
      }
    }
  }
`;
